// extracted by mini-css-extract-plugin
module.exports = {"main_content":"main_content-1mF1eaKb","page_list":"page_list-36QcIqLa clearfix","current":"current-pheTUqks","end":"end-37GBinZ_"};